import type { BoldOptions as TiptapBoldOptions } from '@tiptap/extension-bold'
import { Bold as TiptapBold } from '@tiptap/extension-bold'

import { ActionButton } from '@/components/editor'
import { GeneralOptions } from '@/types'

export interface BoldOptions extends TiptapBoldOptions, GeneralOptions<BoldOptions> {}

export const Bold = TiptapBold.extend<BoldOptions>({
  addOptions() {
    return {
      ...this.parent?.(),
      button: ({ editor }) => ({
        component: ActionButton,
        componentProps: {
          action: () => editor.commands.toggleBold(),
          isActive: () => editor.isActive('bold') || false,
          disabled: !editor.can().toggleBold(),
          icon: 'Bold',
          shortcutKeys: ['mod', 'B'],
          tooltip: 'Bold',
        },
      }),
    }
  },
})
